import type { Dispatch } from 'redux';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { connect } from '@atlassian/jira-react-redux';
import { saveRunAsUser, setShowDialog } from '../../../../state/actions/run-as-user';
import {
	getRunAsUserSubmitStatus,
	maybeRunAsUser,
	runAsUserDialogIsOpen,
} from '../../../../state/selectors/run-as-user';
import type { State as SummaryState } from '../../../../state/types';
import DialogContent from '../dialog-content';
import SettingsDialog from './view';

const mapStateToProps = (state: SummaryState) => ({
	isOpen: runAsUserDialogIsOpen(state),
	storedRunAsUserAccountId: maybeRunAsUser(state)
		// @ts-expect-error - TS7006 - Parameter 'user' implicitly has an 'any' type.
		.map((user) => user.accountId || '')
		.orSome(''),
	submitStatus: getRunAsUserSubmitStatus(state),
	ContentComponent: DialogContent,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	onSave: (accountId: string, event?: UIAnalyticsEvent) =>
		dispatch(saveRunAsUser(accountId, event)),
	onClose: () => dispatch(setShowDialog(false)),
	onToggle: (isOpen: boolean) => dispatch(setShowDialog(!isOpen)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsDialog);
